module.exports = __webpack_public_path__ + "img/manageTopic.eacea809.svg";